import Vue from 'vue'
import { API_URL } from '../../api'
import TransactionsFilter from '../../filters/TransactionsFilter';
import TransactionCategoriesFilter from '../../filters/TransactionCategoriesFilter';
const state = {
    transactionCreate: {
        createdTransaction: null,
        creatingTransaction: false,
        createTransactionStatus: null
    },
    transactionUpdate: {
        updatedTransaction: null,
        updatingTransaction: false,
        updateTransactionStatus: null
    },
    transactionDelete: {
        deletingTransaction: false,
        deleteTransactionStatus: null
    },
    transactionSearch: {
        transactionsCount: null,
        transactions: [],
        searchingTransactions: false,
        searchtransactionStatus: null
    },

    projectAccountTransactionCreate: {
        createdProjectAccountTransaction: null,
        creatingProjectAccountTransaction: false,
        createProjectAccountTransactionStatus: null
    },
    projectAccountTransactionUpdate: {
        updatedProjectAccountTransaction: null,
        updatingProjectAccountTransaction: false,
        updateProjectAccountTransactionStatus: null
    },
    projectAccountTransactionDelete: {
        deletingProjectAccountTransaction: false,
        deleteProjectAccountTransactionStatus: null
    },
    projectAccountTransactionSearch: {
        projectAccountTransactionsCount: null,
        projectAccountTransactions: [],
        searchingProjectAccountTransactions: false,
        searchProjectAccountTransactionStatus: null
    },
    transactionCategorySearch: {
        projectTransactionCategories: [],
        searchingProjectTransactionCategories: false,
        searchProjectTransactionCategoryStatus: null
    }
}
const mutations = {
    ['SET_TRANSACTION_CREATE'](state, change) {
        state.transactionCreate = { ...state.transactionCreate, ...change };
    },
    ['SET_TRANSACTION_UPDATE'](state, change) {
        state.transactionUpdate = { ...state.transactionUpdate, ...change };
    },
    ['SET_TRANSACTION_DELETE'](state, change) {
        state.transactionDelete = { ...state.transactionDelete, ...change };
    },
    ['SET_TRANSACTION_SEARCH'](state, change) {
        state.transactionSearch = { ...state.transactionSearch, ...change };
    },

    ['SET_PROJECT_ACCOUNT_TRANSACTION_CREATE'](state, change) {
        state.transactionCreate = { ...state.projectAccountTransactionCreate, ...change };
    },
    ['SET_PROJECT_ACCOUNT_TRANSACTION_UPDATE'](state, change) {
        state.projectAccountTransactionUpdate = { ...state.projectAccountTransactionUpdate, ...change };
    },
    ['SET_PROJECT_ACCOUNT_TRANSACTION_DELETE'](state, change) {
        state.projectAccountTransactionDelete = { ...state.projectAccountTransactionDelete, ...change };
    },
    ['SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH'](state, change) {
        state.projectAccountTransactionSearch = { ...state.projectAccountTransactionSearch, ...change };
    },
    ['SET_TRANSACTION_CATEGORY_SEARCH'](state, change) {
        state.transactionCategorySearch = { ...state.transactionCategorySearch, ...change };
    }
}
const actions = {
    searchTransactionCategories: ({ commit }, payload = { filter: TransactionCategoriesFilter(), resultMode: 'default' }) => {
        commit('SET_TRANSACTION_CATEGORY_SEARCH', { searchTransactionCategoryStatus: null, searchTransactionCategory: null, searchingTransactionCategories: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/transaction/categories' + params).then(response => {
            commit('SET_TRANSACTION_CATEGORY_SEARCH', { searchTransactionCategoryStatus: 'success', transactionCategories: response.body.results.transactionCategories });
        }).catch(response => {
            commit('SET_TRANSACTION_CATEGORY_SEARCH', { searchTransactionCategoryStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_CATEGORY_SEARCH', { searchingTransactionCategories: false });
        })
    },
    createTransaction: ({ commit }, payload) => {
        commit('SET_TRANSACTION_CREATE', { createTransactionStatus: null, createdTransaction: null, creatingTransaction: true })
        return Vue.http.post(API_URL + '/transactions/create', payload).then(response => {
            commit('SET_TRANSACTION_CREATE', { createTransactionStatus: 'success', createdTransaction: response.body.results.transaction });
        }).catch(response => {
            commit('SET_TRANSACTION_CREATE', { createTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_CREATE', { creatingTransaction: false });
        });
    },
    updateTransaction: ({ commit }, payload) => {
        commit('SET_TRANSACTION_UPDATE', { updateTransactionStatus: null, updatedTransaction: null, updatingTransaction: true })
        return Vue.http.post(API_URL + '/transactions/update/' + payload.id, payload)
            .then(response => {
                commit('SET_TRANSACTION_UPDATE', { updateTransactionStatus: 'success', updatedTransaction: response.body.results.transaction });
            })
            .catch(response => {
                commit('SET_TRANSACTION_UPDATE', { updateTransactionStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_TRANSACTION_UPDATE', { updatingTransaction: false });
            })
    },
    deleteTransaction: ({ commit }, id) => {
        commit('SET_TRANSACTION_DELETE', { deleteTransactionStatus: null, deletedTransaction: null, deletingTransaction: true })
        return Vue.http.delete(API_URL + '/transactions/delete/' + id).then(response => {
            commit('SET_TRANSACTION_DELETE', { deleteTransactionStatus: 'success' });
        }).catch(response => {
            commit('SET_TRANSACTION_DELETE', { deleteTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_DELETE', { deletingTransaction: false });
        })
    },
    searchTransactions: ({ commit }, payload = { filter: TransactionsFilter(), resultMode: 'default' }) => {
        commit('SET_TRANSACTION_SEARCH', { searchtransactionStatus: null, searchtransaction: null, searchingTransactions: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/transactions' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_TRANSACTION_SEARCH', { searchtransactionStatus: 'success', transactionsCount: response.body.results.transactions });

            } else if (payload.resultMode == 2) {
                commit('SET_TRANSACTION_SEARCH', { searchtransactionStatus: 'success', transactionsPaginated: response.body.results.transactions });

            } else {
                commit('SET_TRANSACTION_SEARCH', { searchtransactionStatus: 'success', transactions: response.body.results.transactions });
            }
        }).catch(response => {
            commit('SET_TRANSACTION_SEARCH', { searchtransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_SEARCH', { searchingTransactions: false });
        })
    },

    createProjectAccountTransaction: ({ commit }, payload) => {
        commit('SET_PROJECT_ACCOUNT_TRANSACTION_CREATE', { createProjectAccountTransactionStatus: null, createdProjectAccountTransaction: null, creatingProjectAccountTransaction: true })
        return Vue.http.post(API_URL + '/project/account/transactions/create', payload).then(response => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_CREATE', { createProjectAccountTransactionStatus: 'success', createdProjectAccountTransaction: response.body.results.projectAccountTransaction });
        }).catch(response => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_CREATE', { createProjectAccountTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_CREATE', { creatingProjectAccountTransaction: false });
        });
    },
    updateProjectAccountTransaction: ({ commit }, payload) => {
        commit('SET_PROJECT_ACCOUNT_TRANSACTION_UPDATE', { updateProjectAccountTransactionStatus: null, updatedProjectAccountTransaction: null, updatingProjectAccountTransaction: true })
        return Vue.http.post(API_URL + '/project/account/transactions/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_ACCOUNT_TRANSACTION_UPDATE', { updateProjectAccountTransactionStatus: 'success', updatedProjectAccountTransaction: response.body.results.projectAccountTransaction });
            })
            .catch(response => {
                commit('SET_PROJECT_ACCOUNT_TRANSACTION_UPDATE', { updateProjectAccountTransactionStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_ACCOUNT_TRANSACTION_UPDATE', { updatingProjectAccountTransaction: false });
            })
    },
    deleteProjectAccountTransaction: ({ commit }, id) => {
        commit('SET_PROJECT_ACCOUNT_TRANSACTION_DELETE', { deleteProjectAccountTransactionStatus: null, deletedProjectAccountTransaction: null, deletingProjectAccountTransaction: true })
        return Vue.http.delete(API_URL + '/project/account/transactions/delete/' + id).then(response => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_DELETE', { deleteProjectAccountTransactionStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_DELETE', { deleteProjectAccountTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_DELETE', { deletingProjectAccountTransaction: false });
        })
    },
    searchProjectAccountTransactions: ({ commit }, payload = { filter: TransactionsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH', { searchProjectAccountTransactionStatus: null, searchProjectAccountTransaction: null, searchingProjectAccountTransactions: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/project/account/transactions' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH', { searchProjectAccountTransactionStatus: 'success', projectAccountTransactionsCount: response.body.results.projectAccountTransactions });

            } else if (payload.resultMode == 2) {
                commit('SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH', { searchProjectAccountTransactionStatus: 'success', projectAccountTransactionsPaginated: response.body.results.projectAccountTransactions });

            } else {
                commit('SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH', { searchProjectAccountTransactionStatus: 'success', projectAccountTransactions: response.body.results.projectAccountTransactions });
            }
        }).catch(response => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH', { searchProjectAccountTransactionStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_ACCOUNT_TRANSACTION_SEARCH', { searchingProjectAccountTransactions: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/transactionStore.js